import React from 'react';

import s from './styles.module.scss';
import BingoMiddleStar from './middle-star';

interface IBingoCardProps {
  cardNumber: number;
  bingoNumbers: number[];
  openedNumbers: number[];
}

export default function BingoCard(props: IBingoCardProps) {
  const { cardNumber, bingoNumbers, openedNumbers } = props;
  return (
    <div data-cy="bingo-card-wrapper" className={s['card-wrapper']}>
      <h4 data-cy="bingo-letter">B</h4>
      <h4 data-cy="bingo-letter">I</h4>
      <h4 data-cy="bingo-letter">N</h4>
      <h4 data-cy="bingo-letter">G</h4>
      <h4 data-cy="bingo-letter">O</h4>
      {bingoNumbers.map((number, key) => {
        return (
          <h3
            data-cy="bingo-value"
            key={`${key}-${cardNumber}-bingo-card`}
            className={`${openedNumbers.includes(number) && s.openedNumber} ${
              !number && s.starWrapper
            }`}
          >
            {number || (
              <div className={`${s.middleStar}`}>
                <BingoMiddleStar />
              </div>
            )}
          </h3>
        );
      })}
    </div>
  );
}
